import isEmpty from "lodash/isEmpty";
import lodashStartCase from "lodash/startCase";

import RvxTag from "components/RvxTag";
import ChangeList from "components/LogItem/elements/ChangeList";
import EntryDetails from "components/LogItem/elements/EntryDetails";
import { importSuffix } from "components/LogItem/messages/importSuffix";
import {
  MODEL_ROUTES,
  getModelLink,
  parseCustomTableAuditableType,
  resolveModelDisplay,
} from "components/LogItem/messages/modelLinks";

export function getInfoChangedMessage({
  user_name,
  contact_id,
  contact_name,
  entity_id,
  entity_name,
  changes,
  auditable_type,
  value = null,
  auditable_id,
  data_job_id = null,
  case_id = null,
  case_name = null,
  campaign_name = null,
  info = null,
  custom_table_singular_name = null,
}) {
  const user = user_name || "System";
  const revenue_opportunity_id =
    auditable_type === "RevenueOpportunity" && auditable_id;
  const machine_id = auditable_type === "Machine" && info?.machine_id;

  let model = resolveModelDisplay({
    revenue_opportunity_id,
    auditable_type,
    auditable_id,
    custom_table_singular_name,
    machine_id,
    case_id,
    case_name,
    contact_id,
    contact_name,
    entity_id,
    entity_name,
    campaign_name,
  });

  if (
    !parseCustomTableAuditableType(auditable_type) &&
    auditable_type &&
    !(auditable_type in MODEL_ROUTES)
  ) {
    if (auditable_type === "Machine") {
      model = (
        <>
          {model} attached to case{" "}
          {getModelLink(case_id, "Case", { label: case_name })}
        </>
      );
    } else if (auditable_type === "Lead") {
      model = "the CRM lead";
    } else {
      model = (
        <>
          {lodashStartCase(auditable_type).toLowerCase()}
          {value ? ` '${value}'` : ""}
          {model && <> attached to {model}</>}
        </>
      );
    }
  }

  const subject = info?.field_name ? (
    <>
      the {info.field_name} value on the tag <RvxTag tag={info.updated_tag} />{" "}
      of {model}
    </>
  ) : (
    model
  );

  return (
    <>
      <div>
        {user} changed {subject}
        {importSuffix(data_job_id)}.
      </div>
      {!isEmpty(changes) && (
        <ChangeList>
          {changes.map((change, index) => (
            <li key={index}>{change}</li>
          ))}
        </ChangeList>
      )}
      <EntryDetails rows={[{ label: "Reason", value: info?.reason }]} />
    </>
  );
}
